// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newAgentSection_oblD4 {
  background-color: var(--white-color);
  border-radius: 8px;
  border: 1px solid var(--ececf1-border);

  padding: 20px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
}

.rowHeaderCapacities_pwsMP {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;

  p {
    margin: 5px 0;
  }

  span {
    color: var(--_71717a-color);
  }
}

.progressWrapper_z0jdV {
  margin: 16px 0;
}

.responseTitle_hWaqi {
  display: flex;
  align-items: center;
  gap: 10px;
}

.arrowDown_O60yx {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
}

.parametersInfo_VDmVv {
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 300ms;
  -webkit-transition: all 300ms;
  -moz-transition: all 300ms;
  -ms-transition: all 300ms;
  -o-transition: all 300ms;
  overflow: hidden;
  interpolate-size: allow-keywords;

}

.progressBar_TzqFf {
  width: 100%;
  height: 25px;
  background-color: transparent;
  border: 1px solid var(--ced4da-border);
  overflow: hidden;
  border-radius: 4px;
  padding: 4px;
  box-sizing: border-box;
}

.progressFill_ok5fs {
  height: 100%;
  background-color: var(--_10a37f-background);
  transition: width 0.3s ease;
  border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewAgentComponent/ScheduledResponses/ScheduledResponses.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,sCAAsC;;EAEtC,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;;EAE9B;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,gCAAgC;;AAElC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,2BAA2B;EAC3B,kBAAkB;AACpB","sourcesContent":[".newAgentSection {\n  background-color: var(--white-color);\n  border-radius: 8px;\n  border: 1px solid var(--ececf1-border);\n\n  padding: 20px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n}\n\n.rowHeaderCapacities {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n\n  p {\n    margin: 5px 0;\n  }\n\n  span {\n    color: var(--_71717a-color);\n  }\n}\n\n.progressWrapper {\n  margin: 16px 0;\n}\n\n.responseTitle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.arrowDown {\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n}\n\n.parametersInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: all 300ms;\n  -webkit-transition: all 300ms;\n  -moz-transition: all 300ms;\n  -ms-transition: all 300ms;\n  -o-transition: all 300ms;\n  overflow: hidden;\n  interpolate-size: allow-keywords;\n\n}\n\n.progressBar {\n  width: 100%;\n  height: 25px;\n  background-color: transparent;\n  border: 1px solid var(--ced4da-border);\n  overflow: hidden;\n  border-radius: 4px;\n  padding: 4px;\n  box-sizing: border-box;\n}\n\n.progressFill {\n  height: 100%;\n  background-color: var(--_10a37f-background);\n  transition: width 0.3s ease;\n  border-radius: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newAgentSection": `newAgentSection_oblD4`,
	"rowHeaderCapacities": `rowHeaderCapacities_pwsMP`,
	"progressWrapper": `progressWrapper_z0jdV`,
	"responseTitle": `responseTitle_hWaqi`,
	"arrowDown": `arrowDown_O60yx`,
	"parametersInfo": `parametersInfo_VDmVv`,
	"progressBar": `progressBar_TzqFf`,
	"progressFill": `progressFill_ok5fs`
};
export default ___CSS_LOADER_EXPORT___;
